<template>
    <div>
        <ly-form-item label="优惠前" lw="3.5">
            <InputNumber size="small" style="width:60px;" v-model="num"></InputNumber>
        </ly-form-item>
        <ly-form-item label="优惠后" lw="3.5">
            <InputNumber size="small" style="width:60px;" v-model="num2"></InputNumber>
        </ly-form-item>


    </div>
</template>
<script>

export default {
    props: ["bbb",],
    model: {
        prop: "bbb",
        event: "aaa",
    },
    data() {
        return {
            num: 0,
            num2: 0
        }
    },
    methods: {
        tt() {
            if (this.bbb.length > 0) {
                eval('this.' + this.bbb);
            }
        },
        discount(a, b) {
            this.num = a;
            this.num2 = b;
        },
        emit() {

            this.$emit('aaa', "discount(" +
                this.num + "," +
                this.num2 +
                ")")
        }
    },
    mounted() {
        this.tt();
    },
    watch: {
        num(v) {
            this.emit();
        },
        num2() {
            this.emit();
        },
        bbb() {
            this.tt();
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/wuliu/kehu/gongshi/zhuancheYouhui.vue